{
  "clock_in": "Начать работу",
  "clock_out": "Завершить работу",
  "clock_in_now": "Начать сейчас",
  "clock_in_with_comment": "Начать с комментарием",
  "clocked_in_prefix": "Работа",
  "click_to_clock_out": "Нажмите, чтобы завершить работу",
  "comment_placeholder": "Добавить комментарий (необязательно)...",
  "permissions_module_title": "Модуль учёта времени",
  "permissions_module_description": "Доступ к отметке начала и конца рабочего времени",
  "permissions_entries_title": "Записи учёта времени",
  "permissions_entries_description": "Просмотр и редактирование записей учёта времени сотрудников",
  "time_tracking": "Учёт времени",
  "timesheets": "Табель",
  "adjust_time": "Изменить время",
  "view_profile": "Профиль",
  "started": "Начало",
  "finished": "Конец",
  "original": "Исходное",
  "this_week": "Эта неделя",
  "click_to_adjust": "Нажмите для изменения",
  "no_entries": "Нет записей",
  "active": "Активна",
  "active_session_since": "Активная сессия с {date}",
  "active_session": "Активная сессия",
  "delete_entry": "Удалить запись",
  "delete_entry_confirm": "Удалить эту запись учёта времени?",
  "create_entry": "Создать запись",
  "edit_entry": "Редактировать запись",
  "edit_reason": "Причина изменения",
  "clock_in_comment": "Комментарий при входе",
  "clock_out_comment": "Комментарий при выходе",
  "edit_reason_placeholder": "Причина изменения (необязательно)...",
  "date": "Дата",
  "scope_active": "Активные сотрудники",
  "scope_with_entries": "Сотрудники с записями",
  "scope_all": "Все сотрудники",
  "export_summary": "Сводный отчёт",
  "export_detailed": "Детализированный отчёт"
}
